<template>
    <div class="content">
        <div class="loader" v-if="loading"></div>
        <div v-if="!has_offer">
            <base-header class="pb-6 bg-gradient" type="">
                <b-row align-v="center" class="py-4">

                    <b-col lg="12">
                        <template v-if="offer.is_car">
                            <button class="btn btn-primary" @click="toggleOfferType()">
                                <i class="fa fa-car"></i>
                                Neuversicherung
                            </button>
                            <button class="btn" @click="toggleOfferType()">
                                <i class="fa fa-bus"></i>
                                Versichererwechsel
                            </button>
                        </template>

                        <template v-if="!offer.is_car">
                            <button class="btn" @click="toggleOfferType()">
                                <i class="fa fa-car"></i>
                                Neuversicherung
                            </button>
                            <button class="btn btn-primary" @click="toggleOfferType()">
                                <i class="fa fa-bus"></i>
                                Versichererwechsel
                            </button>
                        </template>



                    </b-col>

                </b-row>


                <b-row align-v="center" class="py-4">

                    <b-col lg="12">
                        <template v-if="!offer.softfair_nutzfahrzeug">
                            <button class="btn btn-primary" @click="toggleOfferType('car')">
                                <i class="fa fa-car"></i>
                                PKW
                            </button>
                            <button class="btn" @click="toggleOfferType('van')">
                                <i class="fa fa-bus"></i>
                                Nutzfahrzeug
                            </button>
                        </template>

                        <template v-if="offer.softfair_nutzfahrzeug">
                            <button class="btn" @click="toggleOfferType('car')">
                                <i class="fa fa-car"></i>
                                PKW
                            </button>
                            <button class="btn btn-primary" @click="toggleOfferType('van')">
                                <i class="fa fa-bus"></i>
                                Nutzfahrzeug
                            </button>
                        </template>

                        <template v-if="!offer.is_company">
                            <button class="btn btn-primary" @click="toggleOfferCompany()">
                                <i class="fa fa-user"></i>
                                Privatkunde
                            </button>
                            <button class="btn" @click="toggleOfferCompany()">
                                <i class="fa fa-university"></i>
                                Geschäftskunde
                            </button>
                        </template>

                        <template v-if="offer.is_company">
                            <button class="btn" @click="toggleOfferCompany()">
                                <i class="fa fa-user"></i>
                                Privatkunde
                            </button>
                            <button class="btn btn-primary" @click="toggleOfferCompany()">
                                <i class="fa fa-university"></i>
                                Geschäftskunde
                            </button>
                        </template>

                    </b-col>

                </b-row>
            </base-header>

            <b-container fluid class="mt--6">

                <b-collapse visible id="collapse-data-input">



                    <!-- b-row class="card-wrapper">
                <b-col lg="6" id="main">
                    <b-row class="card-wrapper">
                        <b-col lg="12">
                            <card>
                                

                                <b-row align-v="center" slot="header">
                                    <b-col cols="8">
                                        <h3 slot="header" class="mb-0">
                                            <i class="fa fa-user"></i>
                                            Kundenangebot rechnen
                                        </h3>
                                    </b-col>
                                    <b-col class="text-right">
                                        <a href="#!" class="btn btn-sm btn-primary" @click="setDefaults()">Neues
                                            Angebot</a>
                                        </b-col>
                                </b-row>

                                <div class="Einstufung" v-if="currentAccount.hasRole('admin')">
                                    Admin: Einstufung:
                                    {{ offer.leveling_type }}: {{ offer.enstg[offer.leveling_type] }}
                                    SF: {{ offer.customer_sf }}
                                    SF2: {{ offer.customer_sf2 }}
                                </div>

                               
                                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                                    <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">
                                        <customer title="Kundendaten" icon="fas fa-users"></customer>

                                        <car title="Fahrzeugdaten" icon="fas fa-car" v-if="offer.is_car"></car>
                                        <van title="Fahrzeugdaten" icon="fas fa-van" v-if="offer.is_van"></van>

                                        <insurance title="Informationen zur Versicherung" icon="fas fa-info"
                                            @init="initInsurance"></insurance>

                                    </form>
                                </validation-observer>
                            </card>
                        </b-col>
                    </b-row>

                    <b-row class="card-wrapper">
                        <template v-if="false">
                            <b-col lg="12">
                              
                                <options title="Informationen zur Versicherung" icon="fas fa-info"></options>
                            </b-col>
                        </template>
                    </b-row>
                </b-col>
</b-row -->

                    <b-row>
                        <b-col lg="6">
                            <b-collapse visible id="collapse-fahrerkreis">
                                <soft-fair-fahrerkreis :offer="offer"></soft-fair-fahrerkreis>
                            </b-collapse>
                        </b-col>

                        <b-col lg="6">
                            <b-collapse visible id="collapse-fahrzeug">
                                <soft-fair-fahrzeug :offer="offer"></soft-fair-fahrzeug>
                            </b-collapse>

                        </b-col>
                        <b-col lg="6">
                            <b-collapse visible id="collapse-leistungen">
                                <soft-fair-leistungen :offer="offer"></soft-fair-leistungen>
                            </b-collapse>

                        </b-col>
                        <b-col lg="6">
                            <b-collapse visible id="collapse-stammdaten">
                                <soft-fair-stammdaten :offer="offer"></soft-fair-stammdaten>
                            </b-collapse>
                        </b-col>

                        <b-col lg="6">
                            <b-collapse visible id="collapse-tarifdaten">
                                <soft-fair-tarifdaten :offer="offer"></soft-fair-tarifdaten>
                            </b-collapse>
                        </b-col>

                        <b-col lg="6">
                            <b-collapse visible id="collapse-versicherungsnehmer">
                                <soft-fair-versicherungsnehmer :offer="offer"></soft-fair-versicherungsnehmer>
                            </b-collapse>
                        </b-col>

                        <b-col lg="6">
                            <b-collapse visible id="collapse-versicherung">
                                <soft-fair-vorversicherung :offer="offer"></soft-fair-vorversicherung>
                            </b-collapse>
                        </b-col>

                    </b-row>

                    <!-- b-col lg="6">
                    <div class="loader" v-if="loading">
                    </div>
                    <pricing title="pricing" icon="fas fa-users" v-on:calculate="mayWeCalc()"></pricing>

                    <options title="Optionen" icon="fas fa-users"></options>

                </b-col>

                <b-col lg="12" v-if="false">
                    <base-button type="primary" class="btn btn-primary" @click="submitToApi()"
                        v-if="allDataValidated">Jetzt
                        kalkulieren</base-button>
                </b-col -->
                </b-collapse>

                <b-row>
                    <b-col lg="12" class="text-center mt-4">
                        <base-button type="primary" class="btn btn-primary" @click="calculateOffer()"
                            :disabled="loading">Angebot
                            berechnen</base-button>
                    </b-col>
                </b-row>

                <b-row>
                    <!-- b-collapse visible id="collapse-pricing">

                        <div class="loader" v-if="offer.softfair_loading"></div>
                        here goes all the pricing fo softfair offers
                        <offers-list :offers="offer.softfair_offers"></offers-list>

                    </b-collapse -->
                </b-row>


                <!-- b-row v-if="debugging"> 

            <b-col lg="6">
                <offer-info v-if="currentAccount.isAdmin"></offer-info>
            </b-col>

            <b-col lg="6">
                <calc-info v-if="currentAccount.isAdmin"></calc-info>
            </b-col>

        </b-row -->

            </b-container>


            <!-- b-container fluid class="mt-2">

            RESULTING OFFERS

            <offers-list :offers="offer.softfair_offers"></offers-list>

        </b-container -->



        </div>
        <div v-else>


            <base-header class="pb-6 bg-gradient" type="">
                <b-row align-v="center" class="py-4">

                    <b-col lg="12">


                        Your offer...


                    </b-col>

                </b-row>

            </base-header>

            <b-container fluid class="mt--6">
                <b-card-group class="pricing flex-column flex-md-row mb-3">

                    <div v-for="elem in offer.pricing" :key="elem.id">
                        <template v-if="elem.sum_brut > 0">
                        <h1>{{ elem.title }}</h1>
                        



                        <card id="offerid" header-classes="bg-transparent" body-classes="px-lg-3"
                            class="card-pricing border-0 text-center mb-4">

                            <!-- h2>OFFERS LIST ELEMENT</h2 -->

                            {{ elem.asig_name }}

                            <!-- h4 slot="header" class="text-uppercase ls-1 text-primary py-3 mb-0">Bravo pack</h4 -->

                            <div class="display-2">{{ financial(elem.sum_brut) }} €</div>
                            <span class="text-muted">per application</span>
                            <!-- {{ elem.response }} -->
                            <!-- ul class="list-unstyled my-4">
                                <li v-for="(value, key) in JSON.parse(elem.response)">{{ key }}: {{ value }} </li>
                            </ul -->
                            <p>
                                <textarea rows="3" cols="40" v-model="elem.response"></textarea>  
                            </p>
                           
                                   

                            <ul class="list-unstyled my-4">
                                <li>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <div
                                                class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                                                <i class="fas fa-terminal"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <span class="pl-2">Complete documentation</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <div
                                                class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                                                <i class="fas fa-pen-fancy"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <span class="pl-2">Working materials in Sketch</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <div
                                                class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                                                <i class="fas fa-hdd"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <span class="pl-2">2GB cloud storage</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <base-button type="primary" class="mb-3" @click="has_offer = false">Anpassen</base-button>

                            <base-button type="primary" class="mb-3" @click="acceptOffer(elem.id)">Auswählen</base-button>

                        </card>

                    </template>

                    </div>

                </b-card-group>

            </b-container>






        </div>




        <b-container fluid class="mt-6">

            <b-row>
                <b-col lg="6">

                    <h1>Offer (Frontend)</h1>
                    <div v-if="show_request">
                        <textarea rows="10" cols="100">{{ offer }}</textarea>           
                    </div>
                </b-col>

                <b-col lg="6">

                    <h1>Request (Backend)</h1>
                    <div v-if="show_request">
                        <textarea rows="10" cols="100" v-model="softfair_request"></textarea>           
                    </div>
                </b-col>
            </b-row>

        </b-container>

        <modal :show.sync="modals.error" title="Error" @ok="modals.error = false">
            <h1>Fehler</h1>
            <pre>{{ modals.error_message }}</pre>
        </modal>
    </div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import BaseSlider from "@/components/BaseSlider";
import { Modal, BaseAlert } from "@/components";
import swal from "sweetalert2";

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import Customer from "../cscomponents/avsoffer/Customer";
import Car from "../cscomponents/avsoffer/Car";
import Van from "../cscomponents/avsoffer/Van";
import Insurance from "../cscomponents/avsoffer/Insurance";
import Options from "../cscomponents/avsoffer/Options";
import Pricing from "../cscomponents/avsoffer/Pricing";

/** softfair stuff */
import OffersList from "../cscomponents/softfair/SoftFairOffersList.vue";

import SoftFairFahrerkreis from "../cscomponents/softfair/SoftFairFahrerkreis.vue";
import SoftFairFahrzeug from "../cscomponents/softfair/SoftFairFahrzeug.vue";
import SoftFairLeistungen from "../cscomponents/softfair/SoftFairLeistungen.vue";
import SoftFairStammdaten from "../cscomponents/softfair/SoftFairStammdaten.vue";
import SoftFairTarifdaten from "../cscomponents/softfair/SoftFairTarifdaten.vue";
import SoftFairVersicherungsnehmer from "../cscomponents/softfair/SoftFairVersicherungsnehmer.vue";
import SoftFairVorversicherung from "../cscomponents/softfair/SoftFairVorversicherung.vue";
import SoftFairOffersListElement from "../cscomponents/softfair/SoftFairOffersListElement.vue";


/* debug */
import OfferInfo from "../cscomponents/OfferInfo";
import CalcInfo from "../cscomponents/CalcInfo";

//import dateUtil from 
//import dateUtil from "../../services/date";
//import offerUtil from "../../services/offer";



// All the spcial SoftFair views here
// this.api.getSfOfferStatus



import { mapGetters, mapState, mapMutations, mapActions } from "vuex";

export default {
    name: "SoftFairOffer",
    components: {
        flatPicker,
        [Select.name]: Select,
        [Option.name]: Option,
        BasePagination,
        RouteBreadCrumb,
        BaseSlider,
        Modal,
        Customer,
        Car,
        Van,
        Insurance,
        Options,
        Pricing,
        //OfferInfo,
        // CalcInfo,
        OffersList,
        SoftFairFahrerkreis,
        SoftFairFahrzeug,
        SoftFairLeistungen,
        SoftFairStammdaten,
        SoftFairTarifdaten,
        SoftFairVersicherungsnehmer,
        SoftFairVorversicherung,
        SoftFairOffersListElement,
    },
    data() {
        return {
            has_offer: false,
            show_request: true,
            show_details: {},
            pricing: {},
            loading: false,
            debugging: true,
            offerdata: [],
            softfair_request: {},
            hsntsn: false,
            edtload: false,
            geschaeftsvorfall: [
                "VersichererwechselMitNeuemFahrzeugOderFahrzeugwechsel",
                "VersichererwechselMitBestehendemFahrzeug",
                "Zweitwagen",
                "ErstmaligEinFahrzeugVersichern",
                "TarifumstellungBeimGleichenVersicherer",
                "Wiederinbetriebnahme"],
            modals: {
                notice: false,
                error: false,
                error_message: "",

            },
        };
    },
    props: {
        token: String,
        title: "Kundenangebot rechnen",
        icon: "fa-user",
    },
    methods: {
        show_calc_details(id) {
            console.log("show_calc_details");
            console.log(id);
            console.log(this.show_details[id]);
            return this.show_details[id];
        },
        toggleDetails(id) {
            console.log("toggleDetails");
            console.log(id);
            console.log(this.show_details[id]);
            this.show_details[id] = !this.show_details[id];
        },
        acceptOffer(id) {
            this.$router.push({
                name: "Angebot annehmen",
                params: { token: `${this.offer.id}` },
            })
        },
        toggleOfferType(type) {
            console.log("toggleOfferType");
            console.log(type);
            if (type == 'car') {
                this.offer.softfair_nutzfahrzeug = false;
            } else {
                this.offer.softfair_nutzfahrzeug = true;
            }

        },
        toggleOfferCompany() {
            if (this.offer.is_company) {
                this.offer.is_company = false;
                this.offer.holder_id = 'N';

            } else {
                this.offer.is_company = true;
                this.offer.holder_id = 'N';
            }

        },


        logValidity() {
            return this.allDataValidated();
        },

        customerValidated() {
            console.log(
                "Validity: customer_firstname -> " + this.offer.customer_firstname
            );
            console.log("Validity: dob -> " + this.offer.dob);
            if (!this.offer.dob) {
                return false;
            }
            console.log("Validity: customer_zip -> " + this.offer.customer_zip);
            if (!this.offer.customer_zip) {
                return false;
            }
            console.log("Validity: has_holder -> " + this.offer.has_holder);
            if (!this.offer.has_holder) {
                return false;
            }
            return true;
        },

        allDataValidated: function () {
            if (
                customerValidated()
            ) {
                this.offer.allValidated = true;
                console.log("VALID WE'RE MOVING");
                // submitToApi();
                return true;
            }
        },


        retrieveOffer(token) {

            console.log("RETRIVING OFFER");
            this.zeroPrice();

            this.edtload = true;
            this.loading = true;
            this.$api
                .getSfOffer(token)
                .then((response) => {

                    console.log("THE complete response");
                    console.log(response);
                    console.log("THE pricing response");
                    console.log(response.data.pricing);
                    console.log("THE pricing response end");

                    //console.log(this.offer);  
                    this.offerdata = response.data.offer;
                    //console.log(response.data.offer);
                    //          this.offer = response.data.offer;
                    if (response.data.pricing) {
                        this.offer.pricing = response.data.pricing;
                        this.pricing = response.data.pricing;
                    }

                    if (response.data.request) {
                        console.log("THE request");
                        console.log(response.data.request);
                        this.softfair_request = response.data.request;
                    }

                    this.kravag_ready = true;
                    console.log("THE offer");
                    console.log(this.offer);
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                    this.edtload = false;
                });
        },
        fetchParticipations() {
            this.loading = true;
            let qtp = "car";
            if (this.offer.is_van) {
                qtp = 'van';
            }
            this.$api
                .getParticipations(qtp)
                .then((response) => {
                    this.offer.participations = response.data.items.map((item) => {
                        let str = "";

                        if (item.vk > 0) {
                            str += "Vollkasko SB " + item.vk + " ";
                        }

                        //if (true) {
                        str += "Teilkasko SB " + item.tk + " ";
                        //} 

                        if (item.name == "Nur Haftpflicht") {
                            str = item.name;
                        }

                        return { value: item.id, label: str };
                    });
                })
                .catch((e) => {
                    //console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        financial(x) {
            if (isNaN(Number.parseFloat(x).toFixed(2))) {
                return 0;
            }
            return Number.parseFloat(x).toFixed(2);
        },
        fetchPaymentterms() {
            this.loading = true;
            this.$api
                .getPaymentterms()
                .then((response) => {
                    this.offer.paymentterms = response.data.items.map((item) => {
                        return { value: item.id, label: item.name };
                    });
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.offer.paymentterm = this.offer.paymentterms[0].value;
                    this.loading = false;
                });
        },

        fetchInsurances() {
            this.loading = true;
            this.$api
                .getInsurances()
                .then((response) => {
                    this.insurances = response.data.items.map((item) => {
                        return { value: item.id, label: item.vu_name };
                    });
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // send via apollo
        submitToApi() {
            this.zeroPrice();
            this.edtload = true;
            this.loading = true;
            this.$api
                .createSfOffer(this.offer)
                .then((response) => {
                    console.log(response);
                    console.log(response.data);
                    console.log(response.data.status);
                    // show popup and exit
                    if (response.data.request) {
                        this.softfair_request = response.data.request;
                    }
                    if (response.data.status == 500) {
                        this.handleRequestError(response);
                        return;
                    }
                    console.log(response.data.id);
                    console.log(response.data.pricing);
                    this.offer.id = response.data.id;





                    // redirect to url with ID 
                    this.$router.push({
                        name: 'SoftFair Angebot anzeigen',
                        params: { token: `${this.offer.id}` },
                    })

                    this.retrieveOffer(this.offer.id);

                    if (response.data.request) {
                        this.softfair_request = response.data.request;
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                    this.edtload = false;
                });
        },
        handleRequestError(response) {
            this.modals.error = true;
            this.modals.error_message = response.data.detail;
        },

        zeroPrice() {
            this.offer.pricing = {};
        },
        calculateOffer() {
            this.submitToApi();
        },

        mayWeCalc() {
            this.hsntsn = false;

            console.log("mayWeCalcmayWeCalcmayWeCalcmayWeCalcmayWeCalcmayWeCalcmayWeCalc -> " + this.edtload);
            console.log("VALIDITY edtload -> " + this.edtload);
            if (this.edtload) {
                return false
            }

            if (!this.offer.is_company) {
                console.log("Validity: dob -> " + this.offer.dob);
                if (!this.offer.dob) {
                    return false;
                }
            }
            console.log("Validity: customer_zip -> " + this.offer.customer_zip);
            if (!this.offer.customer_zip) {
                return false;
            }
            console.log("Validity: has_holder -> " + this.offer.has_holder);
            if (this.offer.has_holder) {
                console.log("Validity: holder_zip if -> " + this.offer.holder_zip);
                if (!this.offer.holder_zip) {
                    return false;
                }
            }

            if (this.offer.is_car) {
                console.log("Validity: hsn -> " + this.offer.hsn);
                if (this.offer.hsn && this.offer.hsn.length == 4 && this.offer.tsn && this.offer.tsn.length == 3) {
                    this.hsntsn = true;
                    //return false;
                }
            }

            console.log("Validity: car_first_registration -> " + this.offer.car_first_registration);
            if (!this.offer.car_first_registration) {
                return false;
            }
            console.log("Validity: car_registration -> " + this.offer.car_registration);
            if (!this.offer.car_registration) {
                return false;
            }
            console.log("Validity: insurance_start -> " + this.offer.insurance_start);
            if (!this.offer.insurance_start) {
                return false;
            }

            console.log("Validity: customer_sf -> " + this.offer.customer_sf);
            console.log("Validity: customer_sf -> " + (this.offer.customer_sf === ""));
            if (this.offer.customer_sf === "") {
                console.log("Validity: customer_sf -> " + this.offer.customer_sf === "");
                return false;
            }
            console.log("Validity: customer_sf2 -> " + this.offer.customer_sf2);
            if (this.offer.customer_sf2 === '') {
                return false;
            }

            console.log("Validity: mileage -> " + this.offer.mileage);
            if (!this.offer.mileage) {
                return false;
            }
            console.log("Validity: participation -> " + this.offer.participation);
            if (!this.offer.participation) {
                return false;
            }
            console.log("Validity: paymentterm -> " + this.offer.paymentterm);
            if (!this.offer.paymentterm) {
                return false;
            }
            console.log("IF has_second_vehicle -> " + this.offer.has_second_vehicle);
            if (this.offer.has_second_vehicle != 0) {
                console.log("Validity: second_vehicle_holder -> " + this.offer.second_vehicle_holder);
                if (this.offer.second_vehicle_holder == '') {
                    return false;
                }
                console.log("Validity: sf_holder_sf -> " + this.offer.sf_holder_sf);
                if (this.offer.sf_holder_sf == '') {
                    // return false;
                }
                console.log("Validity: insurance_id -> " + this.offer.insurance_id);
                if (this.offer.insurance_id == '') {
                    return false;
                }
            }
            console.log("Validity: body_id -> " + this.offer.body_id);
            if (this.offer.is_van) {
                if (!this.offer.body_id) {
                    return false;
                }
            }

            if (this.hsntsn || this.offer.is_van) {
                if (this.edtload === false) {
                    this.submitToApi();
                }
            }

        },
        htmlDate() {
            var date = new Date();

            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            var year = date.getFullYear();

            var htmlDates = year + '-' + month + '-' + day;
            //console.log("THEDATE: " + htmlDates);
            return htmlDates;
        },
        setInsurance(insi) {
            this.offer.slected_insurance = insi;

        },
        initInsurance() {
            //  this.setDefaults();
        },

        setSfOfferDefaults() {
        },
        setdasdasdasdasSfOfferDefaults() {

            this.offer.vorgabenVersicherungsdaten.leistungen = {
                diebstahlElektroKabel: "Unwichtig",
                deckungssummenHaftpflicht: "Euro100MioJeSchaden",
                rabattschutzHaftpflicht: "Unwichtig",
                akkuFehlerDurchBedienung: "Unwichtig",
                ausgleichAkkuLeasing: "Unwichtig",
                umweltschadenversicherung: "Unwichtig",
                rabattschutzVollkasko: "Unwichtig",
                rechtAufSchadenrueckkaufKasko: "Unwichtig",
                hackerUndCyberAngriff: "Unwichtig",
                neuwertentschaedigungAkku: "Unwichtig",
                pannenhilfeAkku: "Unwichtig",
                betriebsBremsBruchschaeden: "Unwichtig",
                verzichtAufSelbstbeteiligungBeiGlasreparatur: "Unwichtig",
                verzichtAufAbzugNeuFuerAlt: "Unwichtig",
                personenDeckungssummeHaftpflicht: "Euro12MioJeSchaden",
                neuwertentschaedigung: "Unwichtig",
                ueberfuehrungskosten: "Unwichtig",
                fahrerschutzversicherung: "Unwichtig",
                zusatzleistungenElektroUndHybridfahrzeuge: "Unwichtig",
                schaedenZwischeniehendemUndGezogenemFahrzeug: "Unwichtig",
                dachlawinen: "Unwichtig",
                parkschadenschutz: "Unwichtig",
                kostenFuerWassercontainer: "Unwichtig",
                auslandschadenschutz: "Unwichtig",
                eigenschadendeckung: "Unwichtig",
                wertminderungsausgleichBeiReparaturschaeden: "Unwichtig",
                allRiskAkkuElektro: "Unwichtig",
                mobileLadegeraete: "Unwichtig",
                ueberspannungsschaedenAmAkku: "Unwichtig",
                entsorgungskosten: "Unwichtig",
                werkstattbindung: "OhneWerkstattbindung",
                tierbissfolgeSchaeden: "TierbissFolgeschaedenBis5_000Euro",
                entsorgungskostenAkku: "Unwichtig",
                allRisk: "Unwichtig",
                unfallmeldedienst: "Unwichtig",
                zulassungskosten: "Unwichtig",
                verzichtAufEinwandGroberFahrlaessigkeit: "Unwichtig",
                kurzschlussfolgeschaedenElektro: "Unwichtig",
                rechtAufSchadenruekaufKh: "Unwichtig",
                kaufwertentschaedigung: "Unwichtig",
                diebstahlElektroLadekarte: "Unwichtig",
                mallorcapolice: "DeckungWieHaftpflichtversicherung",
                telematik: "Unwichtig",
                akkuAusgleichLeasingAkku: "Unwichtig",
                sonstigeLeistungenElektroHybridfahrzeuge: "Unwichtig",
                leistungsUpdateGarantie: "Unwichtig",
                tierbissFolgeschaedenElektro: "Unwichtig",
                elementarschaeden: "Unwichtig",
                schutzbrief: "Unwichtig",
                gapDeckung: "Gewuenscht",
                wallboxen: "Unwichtig",
                beitragsfreiMitversicherterMehrwert: "Unwichtig",
                kurzschlussfolgeschaeden: "Unwichtig",
                kollisionMitTieren: "Gewuenscht"
            };

            this.offer.vorgabenVersicherungsdaten.versicherungsnehmerDetails = {
                privat: {
                    stellung: 0,
                    hatJahreskarteOeffentlicherPersonenverkehrZusatz: "BahnComfort",
                    istMitarbeiterAutohersteller: true,
                    tarifgruppe: "Normal",
                    hatAnSicherheitstrainingTeilgenommenDatum: null,
                    hatFuehrerscheinInEuErworben: true,
                    arbeitgeberBranche: 0,
                    wohneigentum: {
                        typ: "EinZweifamilienhaus",
                        versicherungId: 49,
                        istVermietet: false,
                        anzahlVersicherteGefahren: 1
                    },
                    hatPunkteInFlensburg: false,
                    branche: 9900,
                    kinder: null,
                    fuehrerscheindatum: this.htmlDate(),
                    speziellerArbeitgeber: 0,
                    hatWohnsitzSeitMindestens5Jahren: true,
                    mitgliedschaften: null,
                    istVorsteuerAbzugsberechtigt: true,
                    hatAmBegleitetenFahrenTeilgenommen: true,
                    beruf: 1,
                    familienstand: "LedigAlleinstehend"
                },
                firma: null
            };

            this.offer.vorgabenVersicherungsdaten.vorversicherung = {
                vertragsdauerInJahren: 20,
                gesellschaftId: 49,
                kuendigungDurchVorversicherer: false,
                vertragsnummer: null
            };

            this.offer.vorgabenVersicherungsdaten.tarifdaten = {
                rueckstufungBeruecksichtigen: true,
                kaskotyp: "Ohne",
                schadenfreiheitsklasseVollkasko: "SF2",
                hauptfaelligkeitUnterjaehrig: false,
                zahlungsArtUndWeise: "LastschriftJaehrlich",
                versicherungsbeginn: this.htmlDate(),
                geschaeftsvorfall: "VersichererwechselMitNeuemFahrzeugOderFahrzeugwechsel",
                schadenfreiheitsklasseHaftpflicht: "SF2",
                selbstbeteiligungKasko: null,
                finanzierung: "Eigenfinanzierung"
            };
            this.offer.vorgabenVersicherungsdaten.erstfahrzeug = null;
            this.offer.vorgabenVersicherungsdaten.saisonkennzeichen = null;
            this.offer.vorgabenVersicherungsdaten.fahrzeug = {
                nutzfahrzeug: null,
                pkw: {
                    tsn: "ABN",
                    hsn: "1313",
                    erstmaligeZulassungAufVersicherungsnehmer: this.htmlDate(),
                    fahrzeugNutzung: "AusschliesslichPrivat",
                    auslandNutzung: "Keine",
                    assistenzsysteme: {
                        tagfahrlicht: "KeineAngaben",
                        unfalldatenschreiber: "KeineAngaben",
                        abstandsregeltempomat: "KeineAngaben",
                        antiblockiersystem: "KeineAngaben",
                        elektronischesStabilitaetsprogramm: "KeineAngaben",
                        spurhalteassistent: "KeineAngaben",
                        spurwechselassistent: "KeineAngaben",
                        elektronischeDiebstahlwarnanlage: "KeineAngaben",
                        nachtsichtassistent: "KeineAngaben",
                        bremsassistent: "KeineAngaben",
                        fahrzeugortungssystem: "KeineAngaben",
                        elektronischeWegfahrsperre: "KeineAngaben"
                    },
                    fahrleistungProJahr: 10000,
                    kilometerstand: 10000,
                    erstzulassungsDatum: this.htmlDate(),
                    istAlsBetriebsausgabeAnerkannt: false,
                    stellplatzArt: "AbschliessbareEinzelDoppelgarage",
                    manuelleTypklassen: null,
                    istErstbesitzer: false,
                    neuwertEuro: 40000
                },
                camping: null,
                mofa: null,
                krad: null
            };
            this.offer.vorgabenVersicherungsdaten.abweichenderHalter = null;
            this.offer.vorgabenVersicherungsdaten.vorschaeden = null;






        },
        setBasicDefaults() {
            this.offer.softfair_erstzulassungs_datum = this.htmlDate();
            this.offer.softfair_erstmalige_zulassung_auf_versicherungsnehmer = this.htmlDate();
            this.offer.softfair_versicherungsbeginn = this.htmlDate();
            this.offer.softfair_fuehrerscheindatum = this.htmlDate();
            this.offer.softfair_alter_juengster_nutzer = this.htmlDate();
            this.offer.softfair_alter_aeltester_nutzer = this.htmlDate();
            this.offer.softfair_hat_ansicherheitstraining_teilgenommen_datum = this.htmlDate();
            this.offer.softfair_hsn = "1313";
            this.offer.softfair_tsn = "ABN";
            this.offer.softfair_fahrleistung_pro_jahr = 10000;
            this.offer.softfair_kilometerstand = 10000;
            this.offer.softfair_neuwert_euro = 40000;
            this.offer.softfair_vn_ist_fahrer = true;
            this.offer.softfair_vn_ist_hauptnutzer = true;
            this.offer.softfair_schadenfreiheitsklasse_haftpflicht = "SF2";
            this.offer.softfair_schadenfreiheitsklasse_vollkasko = "SF2";
            this.offer.softfair_selbstbeteiligung_kasko = "Vk500Tk150";
            this.offer.softfair_finanzierung = "Eigenfinanzierung";
            this.offer.softfair_rueckstufung_beruecksichtigen = true;
            //this.offer.softfair_kaskotyp = "Vollkasko";
            this.offer.softfair_geschaeftsvorfall = "VersichererwechselMitNeuemFahrzeugOderFahrzeugwechsel";
            this.offer.softfair_zahlungs_art_und_weise = "LastschriftJaehrlich";
            this.offer.softfair_tarifgruppe = "Normal";
            this.offer.softfair_hat_jahreskarte_oeffentlicher_personenverkehr_zusatz = "BahnComfort";
            this.offer.softfair_arbeitgeber_branche = 0;
            this.offer.softfair_spezieller_arbeitgeber = 0;
            this.offer.softfair_branche = 9900;
            this.offer.softfair_beruf = 1;
            this.offer.softfair_kinder = 0;
            this.offer.softfair_familienstand = "LedigAlleinstehend";
            this.offer.softfair_ist_vorsteuer_abzugsberechtigt = true;
            this.offer.softfair_hat_am_begleiteten_fahren_teilgenommen = true;
            this.offer.softfair_hat_wohn_sitz_seit_mindestens_5_jahren = true;
            this.offer.softfair_hat_punkte_in_flensburg = false;
            this.offer.softfair_hat_fuehrerschein_in_eu_erworben = true;


            this.offer.softfair_elektronische_wegfahrsperre = "KeineAngaben";
            this.offer.softfair_fahrzeugortungssystem = "KeineAngaben";
            this.offer.softfair_bremsassistent = "KeineAngaben";
            this.offer.softfair_nachtsichtassistent = "KeineAngaben";
            this.offer.softfair_elektronische_diebstahlwarnanlage = "KeineAngaben";
            this.offer.softfair_spurwechselassistent = "KeineAngaben";
            this.offer.softfair_spurhalteassistent = "KeineAngaben";
            this.offer.softfair_elektronisches_stabilitaetsprogramm = "KeineAngaben";
            this.offer.softfair_abstandsregeltempomat = "KeineAngaben";
            this.offer.softfair_antiblockiersystem = "KeineAngaben";
            this.offer.softfair_unfalldatenschreiber = "KeineAngaben";
            this.offer.softfair_tagfahrlicht = "KeineAngaben";
            this.offer.softfair_stellplatz_art = "AbschliessbareEinzelDoppelgarage";
            this.offer.softfair_fahrzeug_nutzung = "AusschliesslichPrivat";
            this.offer.softfair_ausland_nutzung = "Keine";
            this.offer.softfair_ist_erstbesitzer = false;
            this.offer.softfair_ist_als_betriebsausgabe_anerkannt = false;
            this.offer.softfair_manuelle_typklassen = null;
            this.offer.softfair_neuwert_euro = 40000;
            this.offer.softfair_fahrleistung_pro_jahr = 10000;
            this.offer.softfair_kilometerstand = 10000;



            this.offer.softfair_diebstahl_elektro_kabel = "Unwichtig"
            this.offer.softfair_deckungssummen_haftpflicht = "Euro100MioJeSchaden"
            this.offer.softfair_rabattschutz_haftpflicht = "Unwichtig"
            this.offer.softfair_akku_fehler_durch_bedienung = "Unwichtig"
            this.offer.softfair_ausgleich_akku_leasing = "Unwichtig"
            this.offer.softfair_umweltschadenversicherung = "Unwichtig"
            this.offer.softfair_rabattschutz_vollkasko = "Unwichtig"
            this.offer.softfair_recht_auf_schadenrueckkauf_kasko = "Unwichtig"
            this.offer.softfair_hacker_und_cyber_angriff = "Unwichtig"
            this.offer.softfair_neuwertentschaedigung_akku = "Unwichtig"
            this.offer.softfair_pannenhilfe_akku = "Unwichtig"
            this.offer.softfair_betriebs_brems_bruch_schaeden = "Unwichtig"
            this.offer.softfair_verzicht_auf_selbstbeteiligung_bei_glasreparatur = "Unwichtig"
            this.offer.softfair_verzicht_auf_abzug_neu_fuer_alt = "Unwichtig"
            this.offer.softfair_personen_deckungssumme_haftpflicht = "Euro5MioJeSchaden"
            this.offer.softfair_neuwertentschaedigung = "Unwichtig"
            this.offer.softfair_ueberfuehrungskosten = "Unwichtig"
            this.offer.softfair_fahrerschutzversicherung = "Unwichtig"
            this.offer.softfair_zusatzleistungen_elektro_und_hybridfahrzeuge = "Unwichtig"
            this.offer.softfair_schaeden_zwischeniehendem_und_gezogenem_fahrzeug = "Unwichtig"
            this.offer.softfair_dachlawinen = "Unwichtig"
            this.offer.softfair_parkschadenschutz = "Unwichtig"
            this.offer.softfair_kosten_fuer_wassercontainer = "Unwichtig"
            this.offer.softfair_auslandschadenschutz = "Unwichtig"
            this.offer.softfair_eigenschadendeckung = "Unwichtig"
            this.offer.softfair_wertminderungsausgleich_bei_reparaturschaeden = "Unwichtig"
            this.offer.softfair_all_risk_akku_elektro = "Unwichtig"
            this.offer.softfair_mobile_ladegeraete = "Unwichtig"
            this.offer.softfair_ueberspannungsschaeden_am_akku = "Unwichtig"
            this.offer.softfair_entsorgungskosten = "Unwichtig"
            this.offer.softfair_werkstattbindung = "OhneWerkstattbindung"
            this.offer.softfair_tierbissfolge_schaeden = "Unwichtig"
            this.offer.softfair_entsorgungskosten_akku = "Unwichtig"
            this.offer.softfair_all_risk = "Unwichtig"
            this.offer.softfair_unfallmeldedienst = "Unwichtig"
            this.offer.softfair_zulassungskosten = "Unwichtig"
            this.offer.softfair_verzicht_auf_einwand_grober_fahrlaessigkeit = "Unwichtig"
            this.offer.softfair_kurzschlussfolgeschaeden_elektro = "Unwichtig"
            this.offer.softfair_recht_auf_schadenrueckkauf_kh = "Unwichtig"
            this.offer.softfair_kaufwertentschaedigung = "Unwichtig"
            this.offer.softfair_diebstahl_elektro_ladekarte = "Unwichtig"
            this.offer.softfair_mallorcapolice = "Unwichtig"
            this.offer.softfair_telematik = "Unwichtig"
            this.offer.softfair_akku_ausgleich_leasing_akku = "Unwichtig"
            this.offer.softfair_sonstige_leistungen_elektro_und_hybridfahrzeuge = "Unwichtig"
            this.offer.softfair_leistungs_update_garantie = "Unwichtig"
            this.offer.softfair_tierbiss_folgeschaeden_elektro = "Unwichtig"
            this.offer.softfair_elementarschaeden = "Unwichtig"
            this.offer.softfair_schutzbrief = "Unwichtig"
            this.offer.softfair_gap_deckung = "Unwichtig"
            this.offer.softfair_wallboxen = "Unwichtig"
            this.offer.softfair_beitragsfrei_mitversicherter_mehrwert = "Unwichtig"
            this.offer.softfair_kurzschlussfolgeschaeden = "Unwichtig"
            this.offer.softfair_kollision_mit_tieren = "Unwichtig"
        },
        setDefaults() {
            this.edtload = true;
            this.$store.dispatch("resetOffer");

            this.offer.customer_sf = '1';
            this.offer.customer_sf2 = '1';
            this.offer.is_car = true;
            //this.offer.softfair_nutzfahrzeug = true;
            this.offer.is_company = false;
            this.offer.has_holder = 0;
            this.offer.customer_has_free_sfr = 1;
            this.offer.holder_only_driver = 1;
            this.offer.mileage = 10000;
            this.offer.participation = 114; // = 10000;
            this.offer.paymentterm = 73; // = 10000;


            this.offer.insurance_number = '';
            this.offer.insurance_id = '';

            this.offer.street = '';
            this.offer.number = '';
            this.offer.customer_street = '';
            this.offer.customer_number = '';
            //this.offer.address.street = '';
            //this.offer.address.number = '';




            console.log("THEDATE: " + this.htmlDate());

            this.offer.car_first_registration = this.htmlDate();
            this.offer.car_registration = this.htmlDate();
            this.offer.insurance_start = this.htmlDate();


            console.log(this.offer.insurance_start);
            console.log(this.$sidebar);

            if (!this.$sidebar.isMinimized) {
                this.$sidebar.toggleMinimize();
            }
            this.edtload = false;

            if (this.offer.is_company == 1) {
                this.offer.second_vehicle_holder = this.offer.possible_sf_holders_company[0].label;
            }

        },
        fetchDetails() {
            this.fetchParticipations();
            this.fetchPaymentterms();
            //this.setDefaultDates();
            this.fetchInsurances();
        },

        /**
         * updates thge old fields for kravag
         * req for compatibility with old kravag
         */
        legacyTypeToggle() {
            if (this.offer.softfair_nutzfahrzeug) {
                this.offer.is_car = false;
                this.offer.is_van = true;
            }
            if (!this.offer.softfair_nutzfahrzeug) {
                this.offer.is_car = true;
                this.offer.is_van = false;
            }
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: "currentAccount",
        }),
        ...mapState({
            offer: (state) => state.softfairOffer,
        }),
        ...mapActions({
            resetOffer: (state) => state.resetOffer,
            setOfferData: (state) => state.setOfferData,
        }),

        maySave: function () {
            return this.allDataValidated();
        },


    },

    watch: {
        '$route'(to, from) {
            //on route change re run: onCreated
            this.setDefaults();

        },
        offer: {
            handler: function (newItem, newValue) {
                console.log("offer changed");
                console.log(newItem);

                this.legacyTypeToggle();
                // this.mayWeCalc();
                /*                if(this.next_step == 0){
                                    this.nextStep();
                                }
                                if(this.next_step == 1){
                                    this.nextStep();
                                }
                  */
            },
            deep: true
        },


        allValidated(newValue, oldValue) {
            console.log(`Updating allValidated from ${oldValue} to ${newValue}`);
            console.log(`WE MAY CALCULATE Now`);
            //this.mayFetchCar();
        },

    },

    mounted: function () {

        console.log("tokentokentokentoken ------> ");
        console.log(this.token);
        console.log("tokentokentokentoken ------> ");

        if (this.token) {

            this.retrieveOffer(this.token);
            this.has_offer = true;

            //this.zeroPrice();

            this.offer.slected_insurance = 'softfair';

            console.log("ISCAR ------> ");
            console.log(this.offer.is_car);
            console.log("ISVAN ------> ");
            console.log(this.offer.is_van);

            //console.log(offerUtil.apply_rules(this.offer));


            console.log("fetchedOFFFFER");
            console.log(this.offer);


            // this.retrieveOffer(this.token);
          //  this.$store.dispatch('setOfferData', this.offer);

        }
        else {
            //  this.retrieveOffer(this.offer.id);

            this.setDefaults();
            this.setSfOfferDefaults();
            this.fetchDetails();

            this.setBasicDefaults();
            this.$store.dispatch('setSoftfairOffer', this.offer);

        }

    },
    created() {
    },
};
</script>
<style>
.spinner {
    width: 40px;
    height: 40px;

    margin: 100px auto;
    z-index: 10000000;
    /*  display: none;*/

    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;

}

.double-bounce1,
.double-bounce2 {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #333;
    opacity: 0.6;
    position: absolute;
    top: 50%;
    left: 50%;

    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
    animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {

    0%,
    100% {
        -webkit-transform: scale(0.0)
    }

    50% {
        -webkit-transform: scale(1.0)
    }
}

@keyframes sk-bounce {

    0%,
    100% {
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
    }

    50% {
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
    }
}

.modal-dialog {
    max-width: 90%;
    margin: 1.75rem auto;
}
</style>